import BaseService from '@/services/BaseService'

class WorkplaceService {

	constructor() {
		this._httpService = new BaseService();
	}

	getWorkplaces() {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces`,
			method: 'GET'
		}
		console.info('get getWorkplaces')
		return this._httpService.service(settings)
	}

	getWorkplace(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${id}`,
			method: 'GET'
		}
		console.info('get getWorkplace')
		return this._httpService.service(settings)
	}

	getWorkplaceTasks(id) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${id}/tasks`,
			method: 'GET'
		}
		console.info('get getWorkplaceTasks')
		return this._httpService.service(settings)
	}

	putStartWorkplaceTask(workplaceId, workplaceScheduleId, employeeId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${workplaceId}/schedules/${workplaceScheduleId}/start/${employeeId}`,
			method: 'PUT'
		}
		console.info('get putStartWorkplaceTask')
		return this._httpService.service(settings)
	}

	putStopWorkplaceTask(workplaceId, workplaceScheduleId, trackId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${workplaceId}/schedules/${workplaceScheduleId}/tracks/${trackId}/stop`,
			method: 'PUT'
		}
		console.info('get putStopWorkplaceTask')
		return this._httpService.service(settings)
	}

	putFinishWorkplaceTask(workplaceId, workplaceScheduleId, trackId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${workplaceId}/schedules/${workplaceScheduleId}/tracks/${trackId}/finish`,
			method: 'PUT'
		}
		console.info('get putFinishWorkplaceTask')
		return this._httpService.service(settings)
	}

	getWorkplaceTasksCount(workplaceId) {
		let settings = {
			baseURL: `${this._httpService.baseUrl}/workplace-management/workplaces/${workplaceId}/tasks-count`,
			method: 'GET'
		}
		console.info('get getWorkplaceTasksCount')
		return this._httpService.service(settings)
	}


}

export default WorkplaceService